import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ThemeModule } from "../@theme/theme.module";
import {
    NbButtonModule,
    NbLayoutModule,
    NbRouteTabsetModule,
    NbTabsetModule,
} from "@nebular/theme";
import { TermsRoutingModule } from "./terms-routing.module";
import { TermsComponent } from "./terms.component";
import { TermsLayoutComponent } from "./terms.layout";
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';

@NgModule({
    declarations: [TermsComponent, TermsLayoutComponent, TermsAndConditionsComponent, PrivacyPolicyComponent, CookiePolicyComponent],
    imports: [
        CommonModule,
        ThemeModule,
        TermsRoutingModule,
        NbButtonModule,
        NbLayoutModule,
        NbRouteTabsetModule,
        NbTabsetModule,
    ],
})
export class TermsModule {}
